import React, { useContext } from 'react';
import PropTypes from 'prop-types';

/**
 * Context for the validation workflow.
 */
export const ValidationContext = React.createContext({});

export const useValidationContext = () => useContext(ValidationContext);

export const ValidationContextProvider = ({
  children,
  ...validationContext
}) => (
  <ValidationContext.Provider value={validationContext}>
    {children}
  </ValidationContext.Provider>
);

ValidationContextProvider.propTypes = {
  /**
   * Validation Rule currently evaluated
   */
  currentValidationRuleName: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
